import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { startWebVitalsReporting } from "./lib/webVitalsReporter";

// Enforce canonical URL: always https://www.placesyoulllove.com
const CANONICAL_HOST = "www.placesyoulllove.com";
if (
  typeof window !== "undefined" &&
  /(^|\.)placesyoulllove\.com$/.test(window.location.hostname) &&
  (window.location.protocol !== "https:" || window.location.hostname !== CANONICAL_HOST)
) {
  window.location.replace(
    `https://${CANONICAL_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
  startWebVitalsReporting();
}
